import RestfulClient from 'restful-json-api-client'

export default class IntegrationsApi extends RestfulClient {
  constructor() {
    super('/api', { resource: 'integrations' })
  }

  checkPaths(platform, repositoryId, paths, branch = null) {
    return this.request('POST', {
      path: 'check_paths',
      body: {
        branch,
        paths,
        platform,
        repository_id: repositoryId
      }
    })
  }

  destroy(id, deleteProjects = false) {
    const query = deleteProjects ? '?delete_projects=true' : ''
    return this.request('DELETE', {
      path: `${id}${query}`
    })
  }
}
